import React from 'react';
import FontAwesome from 'react-fontawesome';



class SymbolSelectItem extends React.Component {

    symbolPath = 'https://www.hundeshop.de/out/pictures/productdesigner/symboles/';

    constructor(props) {
        super(props);

        this.state = {
            isTouchTested: false
        };

        this.handleTouchTested = this.handleTouchTested.bind(this);
        this.handleSelect = this.handleSelect.bind(this);

        if (this.props.designerHasComplex === false && this.props.designerHasSimple === true)
        {
            this.props.onDesignerModeSelect('simple');
        }
        if (this.props.designerHasComplex === true && this.props.designerHasSimple === false)
        {
            this.props.onDesignerModeSelect('complex');
        }
    }

    handleTouchTested(e, isTouch) {
        e.preventDefault();

        if (isTouch)
        {
            this.props.onDesignerModeSelect('simple');
        }
        else
        {
            this.setState({
                isTouchTested: true,
            });
        }
    }

    handleSelect(e, mode) {
        e.preventDefault();
        this.props.onDesignerModeSelect(mode);
    }

    render() {

        if (!this.props.designerHasComplex || !this.props.designerHasSimple)
            return null;

        if (this.state.isTouchTested === false)
        {
            return (
                <div className="row">
                    <div className="col-xs-12 col-sm-8 col-sm-offset-2 text-center">
                        <br />
                        <br />
                        <button className="btn btn-info btn-lg" style={{padding: "20px 60px", height: "60px"}} onClick={(e) => {this.handleTouchTested(e, false)}} onTouchStart={(e) => {this.handleTouchTested(e, true)}}>
                            Jetzt gestalten &nbsp;&nbsp;
                            <FontAwesome name='chevron-right' />
                        </button> 
                        <br />
                        <br />
                    </div>
                </div>
            );
        }

        return (
            <div className="row">
                <div className="col-xs-12 col-sm-8 col-sm-offset-2">
                    <div className="row designer_mode_select">
                        <div className="col-xs-12">
                        </div>
                        <div className="col-xs-12 col-ms-6 col-sm-6" style={{paddingRight: '45px'}}>
                            <h4>Einfacher Designer</h4>
                            <ul>
                                <li><i className="fa fa-check"></i> feste Positionen</li>
                                <li><i className="fa fa-check"></i> schnell und einfach</li>
                            </ul>
                            <img className="img-responsive center-block" src="https://static.hundeshop.de/out/zoxidchild/img/designer_simple.jpg" alt="Designer einfach" /> 
                            <button className="btn btn-info btn-block" onClick={(e) => {this.handleSelect(e, 'simple')}}>
                                Einfachen Designer starten &nbsp;&nbsp;
                                <FontAwesome name='chevron-right' />
                            </button> 
                        </div>
                        <div className="col-xs-12 col-ms-6 col-sm-6" style={{borderLeft: '1px solid #ccc', paddingLeft: '45px'}}>
                            <h4>Experten Designer</h4>
                            <ul>
                                <li><i className="fa fa-check"></i> volle freiheiten</li>
                                <li><i className="fa fa-check"></i> mehr Symbole nutzen</li>
                            </ul> 
                            <img className="img-responsive center-block" src="https://static.hundeshop.de/out/zoxidchild/img/designer_complex.jpg" alt="Designer komplex" /> 
                            <button className="btn btn-info btn-block" onClick={(e) => {this.handleSelect(e, 'complex')}}>
                                Experten Designer starten &nbsp;&nbsp;
                                <FontAwesome name='chevron-right' />
                            </button> 
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SymbolSelectItem;






// WEBPACK FOOTER //
// ./src/DesignerModeSelect.js